module.exports = __webpack_public_path__ + "img/red-desert-2.eee8bdfe.png";